import { env } from "util/env";

export const IS_SANDBOX = env.REACT_APP_SANDBOX;
export const EXTENSION_IDENTIFIER = env.REACT_APP_EXTENSION_IDENTIFIER;
export const ZOHO_CONN_NAME = EXTENSION_IDENTIFIER + "__zoho";
export const DATA_CENTER_URL_API_NAME = EXTENSION_IDENTIFIER + "__Data_Center_URL";
export const ORG_ID_API_NAME = EXTENSION_IDENTIFIER + "__Organization_ID";
export const API_KEY_SET = [
  EXTENSION_IDENTIFIER + "__API_KEY",
  EXTENSION_IDENTIFIER + "__ZAPI_Key",
  EXTENSION_IDENTIFIER + "__Organization_ID",
  EXTENSION_IDENTIFIER + "__Data_Center_URL",
];
